import styled from 'styled-components';

const Uploader = styled.input`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  // width: 100%;
  height: 100%;
  opacity: 0;
  padding: 14px 0;
  cursor: pointer;
`;

export { Uploader };
